export default "__VITE_ASSET__nBBUkRl3__"